







































import Vue from 'vue';
import requester from '@/requester';

export default Vue.extend({
  name: 'ConsultasQueixasCondutasLer',
  props: {
    consultaId: {
      type: Number,
      required: true,
    },
    long: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: {
      queixasCondutas: false,
    },
    queixasCondutas: '',
    errorMsgs: [],
    queixasCondutasBuscada: false,
  }),
  computed: {
    usuario() {
      return this.$store.getters.usuario;
    },
    permissaoVerQueixasCondutasPrivadas() {
      return this.usuario.grupo.alias === 'admin'
        || this.consulta.started_by === this.usuario.id
        || this.consulta.ended_by === this.usuario.id;
    },
  },
  methods: {
    lock() {
      this.queixasCondutas = '';
      this.errorMsgs = [];
      this.queixasCondutasBuscada = false;
    },
    async buscarConsultaQueixasCondutas() {
      if (!this.permissaoVerQueixasCondutasPrivadas) { return; }
      this.loading.queixasCondutas = true;
      try {
        const response = await requester.consulta.consultaQueixasCondutas(this.consultaId);
        if (response.errors.length > 0) {
          this.errorMsgs = response.errors;
        } else {
          this.queixasCondutas = response.data;
        }
        this.queixasCondutasBuscada = true;
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.queixasCondutas = false;
      }
    },
  },
});
